const LETTERS = ["A", "B", "C", "D"];

export function SetQuestion({ question, total, selected, onSelect, disabled }) {
  return (
    <section className="fade-up" data-testid={`set-question-${question.challenge_number}`}>
      <div className="mb-3 flex items-center justify-between">
        <p className="eyebrow text-blue-400">Challenge {question.challenge_number} of {total}</p>
        <p className="eyebrow text-amber-400">{question.points} pts</p>
      </div>
      <div className="panel p-5">
        <p className="whitespace-pre-line font-display text-lg font-semibold leading-snug text-white" data-testid={`question-prompt-${question.challenge_number}`}>{question.prompt}</p>
      </div>
      <div className="mt-3 grid gap-2">
        {question.options.map((opt, i) => {
          const active = selected === i;
          return (
            <button key={i} type="button" onClick={() => onSelect(i)} disabled={disabled}
              className={`flex items-center gap-3 rounded-xl border px-4 py-3.5 text-left transition-[background-color,border-color] duration-150 ${active ? "border-blue-500 bg-blue-500/10" : "border-slate-800 bg-[#111827] hover:border-slate-600 hover:bg-slate-800"}`}
              data-testid={`q${question.challenge_number}-option-${LETTERS[i].toLowerCase()}-button`} aria-pressed={active}>
              <span className={`grid h-8 w-8 shrink-0 place-items-center rounded-lg font-mono text-sm font-bold ${active ? "bg-blue-500 text-white" : "bg-slate-800 text-slate-300"}`}>{LETTERS[i]}</span>
              <span className="text-base font-medium text-slate-100">{opt}</span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
